<template>
  <div class="accordion flex flex-col card">
      <div class="pr-2 py-0 text-xs w-full">
          <a href="#" class="tab__link p-0 no-underline flex flex-wrap content-center items-center" @click.prevent="active = !active">
              <div v-if="icon" class="pl-1"><i aria-hidden="true" class="material-icons leading-tight text-sm">{{icon}}</i></div>
              <div class="font-bold md:pr-3 uppercase w-full md:w-auto">{{title}}</div>
              <div v-if="description" class="font-bold flex-1 w-full md:w-auto md:px-3 uppercase">{{description}}</div>
              <span class="pl-3 leading-tight print:hidden" v-show="!active"><i aria-hidden="true" class="material-icons leading-tight text-base p-0">expand_more</i></span>
              <span class="pl-3 text-block text-red-800" v-show="active"><i aria-hidden="true" class="material-icons leading-tight">cancel</i></span>
          </a>
      </div>
      <div class="w-full" v-show="active">
        <slot />
      </div>            
  </div>
</template>
}
<script>
export default {

  props: {
    title:'',
    icon:'',
    description:'',
    isopen: {
      default: false,
    },
  },
  
  data () {
  return {
      active: false,
    }
  },
}
</script>
